import { create } from "zustand";

type UserUnassignmentDialogStore = {
    isOpen: boolean;
    openUnassignment: () => void;
    close: () => void;
};

export const useUserUnassignmentDialogStore = create<UserUnassignmentDialogStore>((set) => ({
    isOpen: false,
    openUnassignment: () =>
        set(() => ({
            isOpen: true
        })),
    close: () => {
        set(() => ({ isOpen: false}));
        setTimeout(() => {}, 100);
    },
}));